export enum ControleDebitosDI {
  CRIAR_TABELA_USECASE = "CRIAR_TABELA_USECASE",
  CRIAR_TABELA_USECASE_POR_EMPRESA = "CRIAR_TABELA_USECASE_POR_EMPRESA",
  MOSTRAR_CONTROLE_DEBITOS_USE_CASE = "MOSTRAR_CONTROLE_DEBITOS_USE_CASE"
}
